export const LEAD_BANNER_BOTTOM_PORTAL_TARGET = 'lead-banner-bottom-portal-target'

export const LEAD_BANNER_CARDS_PORTAL_TARGET = 'hotel-cards-portal-target';

export const LEAD_BANNER_TOP_PORTAL_TARGET = 'lead-banner-top-portal-target';
